<template>
  <div>
    <DefaultPage id="financials">
      <div class="hero hero--royal-blue">
        <div class="hero-flex-wrap">
          <div class="grid-container">
            <div class="grid-x grid-margin-x">
              <div class="cell medium-8 large-6">
                <div class="hero__call">
                  <div class="hero-part">
                    <h1 class="hero__headline">
                      Strength<br/><span class="text-gold italic-light">in</span> numbers
                    </h1>
                    <div>
                      <a :href="`${baseUrl}SVMIC 2022 Annual Report.pdf`"
                        download="SVMIC 2022 Annual Report"
                        class="download-btn">
                        <div class="download-btn__icon">
                          <div class="download-btn__icon__inner"></div>
                        </div>
                        <div class="download-btn__call">
                          <p class="top">Download <br>Printable PDF</p>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cell medium-4 large-6">
                <div class="grid-x grid-margin-x align-center">
                  <div class="cell large-6 financial-header-photo-col">
                    <div class="financial-header-photo">
                      <div class="pill-mask">
                        <div
                          class="pill-photo"
                          :style="{ backgroundImage:'url(' + require('@/assets/header-melanie-blake.jpg') + ')' }"
                        ></div>
                      </div>
                      <PillsAccent
                        :bottom="0"
                        :left="-100"
                      >
                        <PillColumn>
                          <Pill
                            color="paleBlue"
                            height="medium"
                            :offset="3"
                          />
                          <Pill
                            color="mediumBlue"
                            height="xtall"
                          />
                        </PillColumn>
                        <PillColumn>
                          <Pill
                            color="mediumBlue"
                            height="short"
                          />
                          <Pill
                            color="indigo"
                            height="medium"
                            :offset="1"
                          />
                          <Pill
                            color="paleBlue"
                            height="xxtall"
                          />
                        </PillColumn>
                        <PillColumn>
                          <Pill
                            color="purple"
                            height="tall"
                            :offset="3"
                          />
                          <Pill
                            color="mediumBlue"
                            height="medium"
                          />
                          <Pill
                            color="gold"
                            height="xtall"
                          />
                        </PillColumn>
                      </PillsAccent>
                    </div>
                  </div>
                  <div class="cell large-6 financial-header-photo-col">
                    <div class="financial-header-photo">
                      <div class="pill-mask">
                        <div
                          class="pill-photo"
                          :style="{ backgroundImage:'url(' + require('@/assets/header-katrina-hood.jpg') + ')' }"
                        ></div>
                      </div>
                      <PillsAccent
                        :top="0"
                        :right="-115"
                      >
                        <PillColumn>
                          <Pill
                            color="mediumBlue"
                            height="tall"
                            :offset="4"
                          />
                        </PillColumn>
                        <PillColumn>
                          <Pill
                            color="mediumBlue"
                            height="short"
                            :offset="1"
                          />
                          <Pill
                            color="gold"
                            height="tall"
                          />
                          <Pill
                            color="purple"
                            height="medium"
                          />
                        </PillColumn>
                        <PillColumn>
                          <Pill
                            color="indigo"
                            height="medium"
                          />
                          <Pill
                            color="mediumBlue"
                            height="xtall"
                            :offset="1"
                          />
                        </PillColumn>
                      </PillsAccent>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ContentSection id="highlights"
                      title="Financial Highlights"
                      class="financial-section">
        <template v-slot:titlePills>
          <PillsAccent
            :top="-70"
            :left="-36"
          >
            <PillColumn>
              <Pill
                color="gold"
                height="short"
              />
              <Pill
                color="purple"
                height="tall"
                :offset="1"
              />
            </PillColumn>
          </PillsAccent>
        </template>
        <div class="grid-container">
          <div class="grid-x">
            <div class="cell" data-aos="fade-up">
              <div class="table-scroll">
                <table class="align-table-1">
                  <thead>
                  <tr>
                    <th><h4>At Year End</h4>
                    <p>($ in thousands)</p></th>
                    <th><h4>2018</h4></th>
                    <th><h4>2019</h4></th>
                    <th><h4>2020</h4></th>
                    <th><h4>2021</h4></th>
                    <th><h4>2022</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Cash and Invested Assets</td>
                    <td class="number">1,208,752</td>
                    <td class="number">1,249,626</td>
                    <td class="number">1,294,540</td>
                    <td class="number">1,390,803</td>
                    <td class="number">1,357,781</td>
                  </tr>
                  <tr>
                    <td>Total Assets</td>
                    <td class="number">1,243,394</td>
                    <td class="number">1,278,382</td>
                    <td class="number">1,321,878</td>
                    <td class="number">1,415,225</td>
                    <td class="number">1,385,631</td>
                  </tr>
                  <tr>
                    <td>Loss &amp; Loss Adjustment Expense Reserves</td>
                    <td class="number">469,000</td>
                    <td class="number">455,000</td>
                    <td class="number">456,000</td>
                    <td class="number">468,500</td>
                    <td class="number">461,000</td>
                  </tr>
                  <tr>
                    <td>Policyholders’ Surplus</td>
                    <td class="number">623,955</td>
                    <td class="number">671,735</td>
                    <td class="number">705,694</td>
                    <td class="number">778,138</td>
                    <td class="number">766,831</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="separate-tables"><!--x--></div>
              <div class="table-scroll">
                <table class="align-table-1">
                  <thead>
                  <tr>
                    <th><h4>For The Year</h4>
                      <p>($ in thousands)</p></th>
                    <th><h4>2018</h4></th>
                    <th><h4>2019</h4></th>
                    <th><h4>2020</h4></th>
                    <th><h4>2021</h4></th>
                    <th><h4>2022</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Gross Written Premium</td>
                    <td class="number">120,569</td>
                    <td class="number">119,235</td>
                    <td class="number">113,815</td>
                    <td class="number">121,824</td>
                    <td class="number">137,233</td>
                  </tr>
                  <tr>
                    <td>Net Investment Income</td>
                    <td class="number">32,557</td>
                    <td class="number">29,829</td>
                    <td class="number">28,148</td>
                    <td class="number">26,398</td>
                    <td class="number">35,345</td>
                  </tr>
                  <tr>
                    <td>Net Paid Loss &amp; Loss Adjustment Expenses</td>
                    <td class="number">92,522</td>
                    <td class="number">99,472</td>
                    <td class="number">80,225</td>
                    <td class="number">72,699</td>
                    <td class="number">91,332</td>
                  </tr>
                  <tr>
                    <td>Policyholders’ Dividends Declared</td>
                    <td class="number">7,000</td>
                    <td class="number">7,000</td>
                    <td class="number">7,000</td>
                    <td class="number">7,000</td>
                    <td class="number">7,500</td>
                  </tr>
                  <tr>
                    <td>Net Income</td>
                    <td class="number">28,542</td>
                    <td class="number">22,074</td>
                    <td class="number">23,853</td>
                    <td class="number">17,077</td>
                    <td class="number">21,669</td>
                  </tr>
                  <tr class="spacer-row"></tr>
                  <tr>
                    <td>Cumulative Dividends and Return of Capital</td>
                    <td class="number">363,500</td>
                    <td class="number">370,500</td>
                    <td class="number">377,500</td>
                    <td class="number">384,500</td>
                    <td class="number">392,000</td>
                  </tr>
                  <tr>
                    <td>Cumulative Mutual Value Plan Allocations</td>
                    <td class="number">68,917</td>
                    <td class="number">87,143</td>
                    <td class="number">97,918</td>
                    <td class="number">110,888</td>
                    <td class="number">122,475</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ContentSection>
      <ContentSection id="balance-sheets"
                      title="Condensed Balance Sheets"
                      subtext="(as of December 31, 2022 &amp; 2021)"
                      class="financial-section">
        <template v-slot:titlePills>
          <PillsAccent
            :top="-50"
            :right="-70"
          >
            <PillColumn>
              <Pill
                color="paleBlue"
                height="medium"
                :offset="-1"
              />
            </PillColumn>
            <PillColumn>
              <Pill
                color="purple"
                height="short"
                :offset="2"
              />
            </PillColumn>
          </PillsAccent>
        </template>
        <div class="grid-container">
          <div class="grid-x">
            <div class="cell" data-aos="fade-up">
              <div class="table-scroll">
                <table class="align-table-2 right-aligned">
                  <thead>
                  <tr>
                    <th><h4>Assets</h4></th>
                    <th><h4>2022</h4></th>
                    <th><h4>2021</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Cash &amp; Investments</td>
                    <td class="number">1,357,781,000</td>
                    <td class="number">1,390,803,000</td>
                  </tr>
                  <tr>
                    <td>Premiums Receivable</td>
                    <td class="number">15,084,000</td>
                    <td class="number">14,628,000</td>
                  </tr>
                  <tr>
                    <td>Accrued Investment Income</td>
                    <td class="number">7,956,000</td>
                    <td class="number">7,845,000</td>
                  </tr>
                  <tr>
                    <td>Reinsurance Recoverable</td>
                    <td class="number">3,292,000</td>
                    <td class="number">1,547,000</td>
                  </tr>
                  <tr>
                    <td>Federal Income Taxes Recoverable</td>
                    <td class="number">1,287,000</td>
                    <td class="number">207,000</td>
                  </tr>
                  <tr>
                    <td class="bb">Other Assets</td>
                    <td class="bb number">231,000</td>
                    <td class="bb number">195,000</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <th>TOTAL ASSETS</th>
                    <th class="number">$1,385,631,000</th>
                    <th class="number">$1,415,225,000</th>
                  </tr>
                  </tfoot>
                </table>
              </div>
              <div class="separate-tables"><!--x--></div>
              <div class="table-scroll">
                <table class="align-table-2 right-aligned">
                  <thead>
                  <tr>
                    <th>
                      <h4>Liabilities &amp; Policyholders’ Surplus</h4>
                      <p>Liabilities</p>
                    </th>
                    <th><h4>2022</h4></th>
                    <th><h4>2021</h4></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Loss &amp; Loss Adjustment Expense Reserves</td>
                    <td class="number">461,000,000</td>
                    <td class="number">468,500,000</td>
                  </tr>
                  <tr>
                    <td>Unearned Premiums</td>
                    <td class="number">69,742,000</td>
                    <td class="number">65,862,000</td>
                  </tr>
                  <tr>
                    <td>Reinsurance Balances Payable</td>
                    <td class="number">29,606,000</td>
                    <td class="number">19,260,000</td>
                  </tr>
                  <tr>
                    <td>Accounts Payable and Accrued Expenses</td>
                    <td class="number">41,930,000</td>
                    <td class="number">58,343,000</td>
                  </tr>
                  <tr>
                    <td>Net Deferred Tax Liabilities</td>
                    <td class="number">9,774,000</td>
                    <td class="number">17,393,000</td>
                  </tr>
                  <tr>
                    <td>Dividends Payable</td>
                    <td class="number">2,735,000</td>
                    <td class="number">2,714,000</td>
                  </tr>
                  <tr>
                    <td class="bb">Other Liabilities</td>
                    <td class="bb number">4,013,000</td>
                    <td class="bb number">5,015,000</td>
                  </tr>
                  <tr>
                    <th>Total Liabilities</th>
                    <th class="number">$618,800,000</th>
                    <th class="number">$637,087,000</th>
                  </tr>
                  </tbody>
                </table>
                <br>
                <table class="align-table-2 right-aligned">
                  <tbody>
                  <tr>
                    <th><p class="sub-title-financial">Policyholders’ Surplus</p></th>
                  </tr>
                  <tr>
                    <th style="font-weight: 600;" class="bb">Total Policyholders’ Surplus</th>
                    <th style="font-weight: 600;" class="bb number">$766,831,000</th>
                    <th style="font-weight: 600;" class="bb number">$778,138,000</th>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr>
                    <th>TOTAL LIABILITIES &amp; POLICYHOLDERS’ SURPLUS</th>
                    <th class="number">$1,385,631,000</th>
                    <th class="number">$1,415,225,000</th>
                  </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </ContentSection>
      <ContentSection id="statements-of-income"
                      title="Condensed Statements of Income"
                      subtext="(For the years ended December 31, 2022 &amp; 2021)"
                      class="financial-section">
        <template v-slot:titlePills>
          <PillsAccent
            :top="-90"
            :right="-60"
          >
            <PillColumn>
              <Pill
                color="mediumBlue"
                height="xtall"
                :offset="-1"
              />
              <Pill
                color="gold"
                height="medium"
              />
            </PillColumn>
            <PillColumn>
              <Pill
                color="purple"
                height="xtall"
                :offset="2"
              />
              <Pill
                color="mediumBlue"
                height="medium"
              />
            </PillColumn>
          </PillsAccent>
        </template>
        <div class="grid-container">
          <div class="grid-x">
            <div class="cell" data-aos="fade-up">
              <div class="table-scroll">
                <table class="align-table-2 right-aligned">
                  <thead>
                    <tr>
                      <th><h4>&nbsp;</h4></th>
                      <th><h4>2022</h4></th>
                      <th><h4>2021</h4></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Gross Written Premium</td>
                      <td class="number">137,233,000</td>
                      <td class="number">121,824,000</td>
                    </tr>
                    <tr>
                      <td>Ceded Premium</td>
                      <td class="number">(27,228,000)</td>
                      <td class="number">(11,934,000)</td>
                    </tr>
                    <tr style="border-top: 1px solid black !important;">
                      <td>Net Written Premium</td>
                      <th class="number">$110,005,000</th>
                      <th class="number">$109,890,000</th>
                    </tr>
                    <tr>
                      <td>Change in Unearned Premium</td>
                      <td class="number">(3,880,000)</td>
                      <td class="number">(2,777,000)</td>
                    </tr>
                    <tr style="border-top: 1px solid black !important;">
                      <td>Net Earned Premium</td>
                      <th class="number no-extra-padding">$106,125,000</th>
                      <th class="number no-extra-padding">$107,113,000</th>
                    </tr>
                    <tr class="spacer-row"></tr>
                    <tr>
                      <td>Loss &amp; Loss Adjustment Expenses Incurred</td>
                      <td class="number">83,832,000</td>
                      <td class="number">85,199,000</td>
                    </tr>
                    <tr>
                      <td>Other Underwriting Expenses</td>
                      <td class="number">25,166,000</td>
                      <td class="number">23,892,000</td>
                    </tr>
                  </tbody>
                  <tbody class="bl-border">
                    <tr>
                      <td>Net Underwriting Income</td>
                      <th class="number">($2,873,000)</th>
                      <th class="number">($1,978,000)</th>
                    </tr>
                    <tr class="spacer-row"></tr>
                    <tr>
                      <td>Net Investment Income</td>
                      <td class="number">35,345,000</td>
                      <td class="number">26,398,000</td>
                    </tr>
                    <tr>
                      <td>Net Realized Capital Gains (Losses) on Investments</td>
                      <td class="number">(678,000)</td>
                      <td class="number">2,588,000</td>
                    </tr>
                    <tr>
                      <td>Other Income (Expense)</td>
                      <td class="number">(10,000)</td>
                      <td class="number">(3,000)</td>
                    </tr>
                    <tr style="border-top: 1px solid black !important;">
                      <td>Net Income Before Taxes and Policyholders’ Dividends</td>
                      <td class="number bold">$31,784,000</td>
                      <td class="number bold">$27,005,000</td>
                    </tr>
                    <tr>
                      <td class="bb">Policyholders’ Dividends &amp; Federal Income Taxes Incurred</td>
                      <td class="bb number">(10,115,000)</td>
                      <td class="bb number">(9,928,000)</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td>Net Income</td>
                      <td class="number">$21,669,000</td>
                      <td class="number">$17,077,000</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="grid-x">
            <div class="cell large-7 medium-9">
              <p class="note">Note: The financial statements have been prepared in conformity with accounting practices
                prescribed or permitted by the Tennessee Department of Commerce and Insurance. The condensed financial
                information has been derived from the complete statutory-basis financial statements which were audited
                by Ernst &amp; Young LLP, our independent auditors. A complete set of audited financial statements is
                available upon request.</p>
            </div>
          </div>
        </div>
      </ContentSection>
      <ContentSection id="mvp-allocations"
                      title="Mutual Value Plan&reg; Allocations">
        <template v-slot:titlePills>
          <PillsAccent
            :top="-50"
            :left="-36"
          >
            <PillColumn>
              <Pill
                color="gold"
                height="xtall"
                :offset="2"
              />
            </PillColumn>
            <PillColumn>
              <Pill
                color="paleBlue"
                height="medium"
              />
            </PillColumn>
          </PillsAccent>
        </template>
        <div class="grid-container">
          <ChartContainer>
            <MvpAllocationsChart/>
          </ChartContainer>
          <p class="note chart-note">Established in 2018</p>
        </div>
      </ContentSection>
      <ContentSection id="mvp-distributions"
                      title="Mutual Value Plan&reg; Distributions">
        <template v-slot:titlePills>
          <PillsAccent
            :top="-50"
            :left="-36"
          >
            <PillColumn>
              <Pill
                color="gold"
                height="xtall"
                :offset="2"
              />
            </PillColumn>
            <PillColumn>
              <Pill
                color="paleBlue"
                height="medium"
              />
            </PillColumn>
          </PillsAccent>
        </template>
        <div class="grid-container">
          <ChartContainer>
            <MvpDistributionsChart/>
          </ChartContainer>
          <p class="note chart-note">Established in 2018</p>
        </div>
      </ContentSection>
      <ContentSection id="policyholders-surplus"
                      title="Policyholders' Surplus &amp; Total Assets"
                      class="financial-section">
        <template v-slot:titlePills>
          <PillsAccent
            :top="-50"
            :right="-60"
          >
            <PillColumn>
              <Pill
                color="indigo"
                height="medium"
              />
            </PillColumn>
            <PillColumn>
              <Pill
                color="purple"
                height="tall"
                :offset="2"
              />
            </PillColumn>
          </PillsAccent>
        </template>
        <div class="grid-container">
          <div class="chart-label-container"
               data-aos="fade-down">
            <div class="grid-x">
              <div class="large-3 small-6">
                <div class="chart-label">
                  <div class="dot label2">
                  </div>
                  <p>Policyholders’ Surplus</p>
                </div>
              </div>
              <div class="large-3 small-6">
                <div class="chart-label">
                  <div class="dot label1">
                  </div>
                  <p>Total Assets</p>
                </div>
              </div>
            </div>
          </div>
          <ChartContainer chartClass="chart-container-policyholders-surplus">
            <PolicyholdersSurplusChart/>
          </ChartContainer>
        </div>
      </ContentSection>
      <ContentSection id="cumulative-dividends"
                      title="Cumulative Dividends Declared &amp; Return of Capital">
        <template v-slot:titlePills>
          <PillsAccent
            :top="-50"
            :right="-70"
          >
            <PillColumn>
              <Pill
                color="gold"
                height="tall"
                :offset="-1"
              />
            </PillColumn>
            <PillColumn>
              <Pill
                color="purple"
                height="xtall"
                :offset="1"
              />
            </PillColumn>
          </PillsAccent>
        </template>
        <div class="grid-container">
          <ChartContainer chartClass="chart-container-cumulative-dividends">
            <CumulativeDividendsChart/>
          </ChartContainer>
        </div>
      </ContentSection>
    </DefaultPage>
  </div>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import ContentSection from '@/components/section/VisualDataSection';
import PillsAccent from '@/components/pills/PillsAccent';
import PillColumn from '@/components/pills/PillColumn';
import Pill from '@/components/pills/Pill';
import MvpAllocationsChart from '@/components/chart/MvpAllocationsChart';
import MvpDistributionsChart from '@/components/chart/MvpDistributionsChart';
import PolicyholdersSurplusChart from '@/components/chart/PolicyholdersSurplusChart';
import ChartContainer from '@/components/chart/ChartContainer';
import CumulativeDividendsChart from '@/components/chart/CumulativeDividendsChart';

export default {
  name: 'Financials',
  components: {
    MvpAllocationsChart,
    MvpDistributionsChart,
    CumulativeDividendsChart,
    ChartContainer,
    PolicyholdersSurplusChart,
    ContentSection,
    PillsAccent,
    PillColumn,
    Pill,
    DefaultPage
  },
  data () {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/setup/variables.scss';
#mvp-allocations {
  .cell:first-of-type {
    margin-bottom: 4rem;
    @include breakpoint(large) {
      margin-bottom: 0;
    }
  }
}
</style>
